import {Injectable} from '@angular/core';
import * as moment from 'moment-timezone';


@Injectable({
  providedIn: 'root'
})
export class DateService {


  today = moment().tz('Europe/Rome').locale('it');

  // eslint-disable-next-line @typescript-eslint/naming-convention
  private EDGE_DAY_TIME = moment('08:00', 'HH:mm').tz('Europe/Rome').locale('it');

  private day;

  constructor() {
    moment.locale('it');
    this.setDay();
  }

  actualDate(): number {
    this.setDay();
    return this.day;
  }

  setDay() {
    const now = moment().tz('Europe/Rome').locale('it');
    if (now.isBefore(this.EDGE_DAY_TIME)) {
      this.day = now.subtract(1, 'day').startOf('day').valueOf();
    }
    this.day = now.startOf('day').valueOf();
  }

  getAge(date: Date): number {
    return Math.floor((this.day - this.fromDateToTimestamp(date)) / 31556926000);
  }

  fromTimestampToMoment(timestamp: number) {
    return moment(timestamp).tz('Europe/Rome').locale('it').startOf('day');
  }

  fromStringToMoment(str: string) {
    return moment(str).tz('Europe/Rome').startOf('day');
  }

  fromIsoStringToMoment(str: string) {
    return moment(str).startOf('day');
  }

  fromDateToTimestamp(date: Date) {
    return moment(date).tz('Europe/Rome').locale('it').startOf('day').valueOf();
  }

  fromDateToMoment(date: Date) {
    return moment(date).tz('Europe/Rome').locale('it');
  }

  isSameDay(d: Date, d2: Date): boolean {
    return moment(d).tz('Europe/Rome').isSame(d2, 'day');
  }

  get now() {
    return moment().tz('Europe/Rome').locale('it').toISOString();
  }

  get monthNames(): string[] {
    return moment.months().map(m => m[0].toUpperCase() + m.substr(1).toLowerCase());
  }

  get monthShortNames(): string[] {
    return moment.monthsShort().map(m => m[0].toUpperCase() + m.substr(1).toLowerCase());
  }

  get dayNames(): string[] {
    return moment.weekdaysShort().map(m => m[0].toUpperCase() + m.substr(1).toLowerCase());
  }


}
